export enum AuthStatus {
  SignedIn = 'SIGNED_IN',
  SignedOut = 'SIGNED_OUT',
  ForgotPasswordCodeSent = 'FORGOT_PASSWORD_CODE_SENT',
  PasswordReset = 'PASSWORD_RESET',
}
